/* eslint-disable */
// @ts-nocheck
export const sendTaboolaEvent = (id: string, event: string): void => {
  if (typeof window._tfa === "undefined") {
    !(function (t, f, a, x) {
      if (!document.getElementById(x)) {
        t.async = 1;
        t.src = a;
        t.id = x;
        f.parentNode.insertBefore(t, f);
      }
    })(
      document.createElement("script"),
      document.getElementsByTagName("script")[0],
      `//cdn.taboola.com/libtrc/unip/${id}/tfa.js`,
      "tb_tfa_script",
    );
    window._tfa = window._tfa || [];
    window._tfa.push({ notify: "event", name: "page_view", id });
  }
  if (event) {
    window._tfa.push({ notify: "event", name: event, id });
  }
};
